export const checkMobileNumber = (val) => {
    let phoneno = /^\d{10}$/;
    if (!val || val.length <= 0) {
        return 'Mobile number cannot be empty.';
    }
    if (!val.match(phoneno)) {
        return "Mobile number is not valid";
    }
    return '';
}

export const checkNumber = (val) => {
    let regex = new RegExp(/[^0-9]/, 'g');
    if (!val.match(regex)) {
        return "Enter valid Number";
    }
}

export const handleTypeNumber = (e) => {
    let checkIfNum;
    if (e.key !== undefined) {
        checkIfNum = e.key === "e" || e.key === "E" || e.key === "." || e.key === "+" || e.key === "-";
    }
    return checkIfNum && e.preventDefault();
}

export const emailValidator = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!email || email.length <= 0) {
        return 'Email Id cannot be empty.';
    }
    if (!re.test(email)) {
        return 'Email Id is not valid';
    }
    return '';
};

export const OTPValidation = (otp) => {
    let reg = /^\d{6}$/;
    if (!otp || otp.trim().length <= 0) {
        return 'OTP is required.';
    }
    if (!reg.test(otp)) {
        return 'OTP is not valid';
    }
    return '';
}

export const nameValidator = (name) => {
    let reg = /^[a-zA-Z ]*$/g;
    if (!name || name.trim().length <= 0) {
        return 'empty';
    }
    if (!reg.test(name)) {
        return 'character';
    }
    return '';
}

export const panValidator = (pan) => {
    let reg = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

    if (!pan || pan.trim().length <= 0) {
        return 'PAN number is required';
    }
    if (!reg.test(pan)) {
        return 'PAN number is invalid';
    }
    return '';
}

export const GstValidator = (gst) => {
    let reg = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (!gst || gst.trim().length <= 0) {
        return 'GSTIN is required.';
    }
    if (!reg.test(gst)) {
        return 'GSTIN is invalid';
    }
    return '';
}

export const IfscValidator = (ifsc) => {
    let reg = /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/;
    if (!ifsc || ifsc.trim().length <= 0) {
        return 'IFSC code is required';
    }
    if (!reg.test(ifsc)) {
        return 'IFSC code is invalid';
    }
    return '';
}

export const accountNoValidator = (account) => {
    if (!account || account.trim().length <= 0) {
        return 'Account number is required';
    }
    if (account.length < 9 || account.length > 18) {
        return 'Account number is invalid';
    }
    return '';
}

export function CapitalizeFirstLetter(letter) {
    return letter.charAt(0).toUpperCase() + letter.slice(1);
};